import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { OnboardingStatus } from 'src/constants/onboarding/enums'
import { ContractorDetails } from 'src/interfaces/contractor'
import { ContractorFailedStep } from '../ContractorFailedStep'
import { ContractorPendingStep } from '../ContractorPendingStep'
import { ContractorSteps } from '../ContractorSteps'
import { colors } from 'src/theme'

interface OnboardingStepsTabProps {
  contractorDetails: ContractorDetails
  flow: 'onboardings' | 'contractors'
  isRequestApprove?: boolean
  onRefresh(): Promise<void> | void
  isSubcontractor?: boolean
}

const OnboardingStepsTabComponent = memo(
  ({
    contractorDetails,
    flow,
    isRequestApprove,
    onRefresh,
    isSubcontractor,
  }: OnboardingStepsTabProps) => {
    const hasStepsWithRecollectingStatus = contractorDetails.collectedData.some(
      (item) => !!item.isRecollecting,
    )

    return (
      <div css={tw`flex flex-1 flex-col overflow-y-auto h-full bg-[rgba(246, 246, 246, 1)]`}>
        <div css={tw`p-4 pb-20`}>
          {(contractorDetails.collectedDataStatus === OnboardingStatus.Created ||
            contractorDetails.collectedDataStatus === OnboardingStatus.PartiallyCompleted) && (
            <div>
              <ContractorPendingStep contractorDetails={contractorDetails} />
              <ContractorSteps
                isRequestApprove={isRequestApprove}
                contractorDetails={contractorDetails}
                onRefresh={onRefresh}
                isSubcontractor={isSubcontractor}
              />
            </div>
          )}

          {(!contractorDetails.collectedDataStatus ||
            contractorDetails.collectedDataStatus === OnboardingStatus.WaitingForApproval ||
            contractorDetails.collectedDataStatus === OnboardingStatus.Completed) && (
            <div>
              {hasStepsWithRecollectingStatus && flow === 'contractors' && (
                <div css={tw`rounded-2xl bg-white overflow-hidden mb-4`}>
                  <div css={tw`flex flex-col items-center px-4 py-3`}>
                    <Typography color={colors.GRAY_COOL_GRAY} css={tw`mb-1`} variant="subtitle1">
                      Recollection
                    </Typography>
                    <Typography color="black" variant="body2">
                      Pending
                    </Typography>
                  </div>
                </div>
              )}
              {isRequestApprove && (
                <div css={tw`rounded-2xl bg-white overflow-hidden mb-4`}>
                  <div css={tw`flex flex-col items-center px-4 py-3`}>
                    <Typography color={colors.SHADES_GREY_400} css={tw`mb-1`} variant="h6">
                      Approved by Master Contractor
                    </Typography>
                  </div>
                </div>
              )}
              <ContractorSteps
                isRequestApprove={isRequestApprove}
                contractorDetails={contractorDetails}
                onRefresh={onRefresh}
                isSubcontractor={isSubcontractor}
              />
            </div>
          )}

          {contractorDetails.collectedDataStatus === OnboardingStatus.Failed && (
            <div>
              <ContractorFailedStep contractorDetails={contractorDetails} />
              <ContractorSteps
                isRequestApprove={isRequestApprove}
                contractorDetails={contractorDetails}
                onRefresh={onRefresh}
                isSubcontractor={isSubcontractor}
              />
            </div>
          )}
        </div>
      </div>
    )
  },
)

export const OnboardingStepsTab = OnboardingStepsTabComponent
